import { css } from '@emotion/core';

export default {
  barcodeContainer: css`
    svg {
      width: 100%;
    }
  `,
};
